import { useIntl } from 'react-intl'
import LocalizationData from '../data/LocalizationData'

/**
 * Nearby系コンポーネント専用のカスタムフック
 * 日本語以外のロケールを英語に統一します
 */
const useNearbyIntl = () => {
  const intl = useIntl()
  
  // 日本語の場合はja、それ以外はenに統一
  const nearbyLocale = intl.locale === 'ja' ? 'ja' : 'en'
  const nearbyMessages = LocalizationData.getMessagesData(nearbyLocale)
  
  return {
    locale: nearbyLocale,
    messages: nearbyMessages,
    formatMessage: (id) => nearbyMessages[id] || id,
  }
}

export default useNearbyIntl
